/* eslint-disable */
export default {
  en: {
    messages: {
      _default(e) {
        return 'Este campo no es válido.';
      },
      after(e, n) {
        var o = n[0];
        return 'Este campo debe ser posterior ' + (n[1] ? 'o igual ' : '') + 'a ' + o + '.';
      },
      alpha_dash(e) {
        return 'Este campo solo debe contener letras, números y guiones.';
      },
      alpha_num(e) {
        return 'Este campo solo debe contener letras y números.';
      },
      alpha_spaces(e) {
        return 'Este campo solo debe contener letras y espacios.';
      },
      alpha(e) {
        return 'Este campo solo debe contener letras.';
      },
      before(e, n) {
        var o = n[0];
        return 'Este campo debe ser anterior ' + (n[1] ? 'o igual ' : '') + 'a ' + o + '.';
      },
      between(e, n) {
        return 'Este campo debe estar entre ' + n[0] + ' y ' + n[1] + '.';
      },
      confirmed(e) {
        return 'Este campo no coincide.';
      },
      credit_card(e) {
        return 'Este campo es inválido.';
      },
      date_between(e, n) {
        return 'Este campo debe estar entre ' + n[0] + ' y ' + n[1] + '.';
      },
      date_format(e, n) {
        return 'Este campo debe tener formato formato ' + n[0] + '.';
      },
      decimal(e, n) {
        void 0 === n && (n = []);
        var o = n[0];
        return void 0 === o && (o = '*'), 'Este campo debe ser númerico y contener ' + ('*' === o ? '' : o) + ' puntos decimales.';
      },
      digits(e, n) {
        return 'Este campo debe ser númerico y contener exactamente ' + n[0] + ' dígitos.';
      },
      dimensions(e, n) {
        return 'Este campo debe ser de ' + n[0] + ' pixeles por ' + n[1] + ' pixeles.';
      },
      email(e) {
        return 'Este campo debe ser un email electrónico válido.';
      },
      ext(e) {
        return 'Este campo debe ser un archivo válido.';
      },
      image(e) {
        return 'Este campo debe ser una imagen.';
      },
      in(e) {
        return 'Este campo debe ser un valor válido.';
      },
      integer(e) {
        return 'Este campo debe ser un entero.';
      },
      ip(e) {
        return 'Este campo debe ser una dirección ip válida.';
      },
      length(e, n) {
        let o = n[0];
        let r = n[1];
        return r ? 'El largo del campo ' + e + ' debe estar entre ' + o + ' y ' + r + '.' : 'El largo del campo ' + e + ' debe ser ' + o + '.';
      },
      max(e, n) {
        return 'Este campo no debe ser mayor a ' + n[0] + ' caracteres.';
      },
      max_value(e, n) {
        return 'Este campo debe de ser ' + n[0] + ' o menor.';
      },
      mimes(e) {
        return 'Este campo debe ser un tipo de archivo válido.';
      },
      min(e, n) {
        return 'Este campo debe tener al menos ' + n[0] + ' caracteres.';
      },
      min_value(e, n) {
        return 'Este campo debe ser ' + n[0] + ' o superior.';
      },
      not_in(e) {
        return 'Este campo debe ser un valor válido.';
      },
      numeric(e) {
        return 'Este campo debe contener solo caracteres númericos.';
      },
      regex(e) {
        return 'El formato del campo ' + e + ' no es válido.';
      },
      required(e) {
        return 'Este campo es obligatorio.';
      },
      size(e, n) {
        var o, r, t, a = n[0];
        return 'Este campo debe ser menor a ' + (o = a, r = 1024, t = 0 == (o = Number(o) * r) ? 0 : Math.floor(Math.log(o) / Math.log(r)), 1 * (o / Math.pow(r, t)).toFixed(2) + ' ' + ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][t]) + '.';
      },
      url(e) {
        return 'Este campo no es una URL válida.';
      }
    },
  },
};
/* eslint-disable */



// WEBPACK FOOTER //
// ./src/services/validationDictionary.js